import React from 'react';
import { Button } from '@getro/rombo';
import { Check, ThumbsUp } from 'lucide-react';
import PropTypes from 'prop-types';
import { Box, Flex, Link, Text } from 'rebass/styled-components';

import { useOfferIntro } from '../../hooks/useOfferIntro';

export const OfferIntro = ({ contact, company, sharedList, onOfferIntoButtonClicked }) => {
  const { isIntroOffered, offerIntro, isLoading, mailto, onClickMakeIntro } = useOfferIntro({
    contact,
    company,
    sharedList,
    onOfferIntoButtonClicked,
  });

  return isIntroOffered ? (
    <Box>
      <Flex alignItems="center" sx={{ gap: '8px', color: 'green.600' }}>
        <Box as={Check} width="16px" height="16px" aria-hidden="true" />
        <Text fontSize="14px" fontWeight="medium" color="text.dark">
          Intro offered
        </Text>
      </Flex>
      <Text
        sx={{
          whiteSpace: 'wrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        as="p"
        fontSize="14px"
      >
        Wait for a forwardable email from {sharedList?.pointOfContact?.fullName} or{' '}
        <Link href={mailto} sx={{ color: 'text.main' }} onClick={onClickMakeIntro}>
          make the intro now.
        </Link>
      </Text>
    </Box>
  ) : (
    <Button icon={ThumbsUp} size="small" loading={isLoading} onClick={offerIntro}>
      Offer intro
    </Button>
  );
};

OfferIntro.propTypes = {
  contact: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
  sharedList: PropTypes.object.isRequired,
  onOfferIntoButtonClicked: PropTypes.func,
};

OfferIntro.defaultProps = {
  onOfferIntoButtonClicked: () => {},
};
